import React from 'react';
import { InfoIcon } from 'lucide-react';
import { useDefinitions } from '../../contexts/DefinitionsContext';
export function MetricInfoButton({
  id,
  label
}: {
  id: string;
  label: string;
}) {
  const {
    open
  } = useDefinitions();
  return <button type="button" aria-label={`Open definition: ${label}`} title="Definition & calculation" onClick={e => {
    e.stopPropagation();
    open(id);
  }} onKeyDown={e => e.stopPropagation()} className="shrink-0 rounded-full text-ink-subtle transition-colors duration-150 hover:text-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy/30" data-id="element-129" data-mp="4g2jppfff3d3">
      <InfoIcon className="h-3.5 w-3.5" data-id="element-130" data-mp="n73j2ekgl0x6" />
    </button>;
}